<template>
  <div class="hruseractivity w-100">
    <ul
      v-if="dataLog.length"
      class="m-0 p-0 float-left w-100 biometric-scrollable-list"
    >
      <li
        v-for="(log, lindex) in dataLog"
        :key="lindex"
      >
        <div class="d-flex">
          <div class="d-flex justify-content-between align-items-center w-100">
            <p class="activityName mb-0" style="width: 100%; text-transform: none;">
              {{ log.description }}
            </p>
            <div class="activityHours">
              <p class="user-time-log-dashboard mb-0 text-nowrap">
                {{ log.timestamp | dateFromNow }}
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    
    <div
      v-if="dataLog.length === 0"
      class="d-flex align-items-center justify-content-center w-100 pt-5"
    >
      <img
        src="../../../assets/images/nodatafound/nodata.svg"
        alt="no-data"
        class="no-data-img no-data-dashboard"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataLog: {
      default: () => ([]),
      required: false,
      type: Array,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import './biometricLog.scss';
</style>
